import { Box } from '@resideo/blueprint-react';
import styled from 'styled-components';

export const IconCircle = styled(Box)`
  align-items: center;
  background: ${({ theme }) => theme.colors.background};
  border-radius: 50%;
  display: flex;
  flex-shrink: 0;
  height: 48px;
  justify-content: center;
  width: 48px;

  svg {
    height: 24px;
    width: 24px;
  }
`;
